import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  siderCollapsed: boolean;
  toggleSider: () => void;
  setSiderCollapsed: (v: boolean) => void;
  mobileMenuOpen: boolean;
  openMobileMenu: () => void;
  closeMobileMenu: () => void;
  toggleMobileMenu: () => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      siderCollapsed: false,
      toggleSider: () => set((s) => ({ siderCollapsed: !s.siderCollapsed })),
      setSiderCollapsed: (v) => set({ siderCollapsed: v }),
      mobileMenuOpen: false,
      openMobileMenu: () => set({ mobileMenuOpen: true }),
      closeMobileMenu: () => set({ mobileMenuOpen: false }),
      toggleMobileMenu: () => set((s) => ({ mobileMenuOpen: !s.mobileMenuOpen })),
    }),
    {
      name: 'school.ui',
      // Mobile menu state is transient — always start closed on fresh load.
      partialize: (s) => ({ siderCollapsed: s.siderCollapsed }),
    },
  ),
);
